import { render, staticRenderFns } from "./WoksList.vue?vue&type=template&id=4e33e1b1&scoped=true&"
import script from "./WoksList.vue?vue&type=script&lang=ts&"
export * from "./WoksList.vue?vue&type=script&lang=ts&"
import style0 from "./WoksList.vue?vue&type=style&index=0&id=4e33e1b1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33e1b1",
  null
  
)

export default component.exports